import React, { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Panel, DataTable, money, inputCls } from "./shared";

const thisMonth = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Manila" }).slice(0, 7);

export default function CashPositionTab() {
  const [month, setMonth] = useState(thisMonth());
  const [accounts, setAccounts] = useState([]);
  const [days, setDays] = useState([]);
  useEffect(() => { api.get("/finance/cash/accounts").then((r) => setAccounts(r.data)).catch((e) => toast.error(formatError(e))); }, []);
  useEffect(() => {
    api.get("/finance/cash/days").then((r) => setDays(r.data)).catch((e) => toast.error(formatError(e)));
  }, []);

  const dates = [...new Set(days.map((d) => d.date))].sort();
  const carry = {};
  const rows = dates.map((date) => {
    const row = { id: date, date };
    days.filter((d) => d.date === date).forEach((d) => { row[d.account_id] = d; carry[d.account_id] = d.closing; });
    row.total = accounts.reduce((s, a) => s + (carry[a.id] || 0), 0);
    return row;
  }).filter((r) => r.date.startsWith(month)).reverse();
  const cell = (d) => (d ? <div><div>{money(d.closing)}</div><div className="text-[10px] text-slate-500">{d.status === "Open" ? "open" : `in ${money(d.total_in)} · out ${money(d.total_out)}`}</div></div> : "—");
  const columns = [
    { key: "date", label: "Date", mono: true },
    ...accounts.map((a) => ({ key: a.id, label: a.name, right: true, render: (r) => cell(r[a.id]) })),
    { key: "total", label: "Total cash position", right: true, render: (r) => <span className="text-sky-300">{money(r.total)}</span> },
  ];
  const overall = accounts.reduce((s, a) => s + (a.latest?.closing || 0), 0);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {accounts.map((a) => (
          <div key={a.id} className="glass-card rounded-lg p-4">
            <div className="text-[10px] uppercase tracking-widest text-slate-500">{a.name}</div>
            <div data-testid={`cash-pos-${a.id}`} className="font-mono-ops text-xl mt-1">{money(a.latest?.closing)}</div>
            <div className="text-[11px] text-slate-500">{a.latest ? `${a.latest.date} · ${a.latest.status}` : "No days yet"}</div>
          </div>
        ))}
        <div className="glass-card rounded-lg p-4 border border-sky-500/40">
          <div className="text-[10px] uppercase tracking-widest text-sky-400">Total cash position</div>
          <div data-testid="cash-pos-total" className="font-mono-ops text-xl mt-1 text-sky-300">{money(overall)}</div>
          <div className="text-[11px] text-slate-500">Latest balance of every account</div>
        </div>
      </div>
      <Panel title="Daily balances" subtitle="Closing balance per account for each day of the month."
             right={<Input data-testid="input-cash-pos-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className={`w-44 ${inputCls}`} />}>
        <DataTable testid="cash-position-table" columns={columns} rows={rows} empty="No days recorded this month." />
      </Panel>
    </div>
  );
}
